import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './HowItWorks.module.css';

const steps = [
  {
    id: 'apply',
    labelId: 'ForProvidersHowItWorks.applyLabel',
    label: '01 · Apply',
    titleId: 'ForProvidersHowItWorks.applyTitle',
    title: 'Tell us about your work',
    textId: 'ForProvidersHowItWorks.applyText',
    text:
      'Share your discipline, credentials, and services. We verify credentials, check references, and set up an intro call. In-home providers also complete a background check.',
  },
  {
    id: 'build',
    labelId: 'ForProvidersHowItWorks.buildLabel',
    label: '02 · Build',
    titleId: 'ForProvidersHowItWorks.buildTitle',
    title: 'Create your profile',
    textId: 'ForProvidersHowItWorks.buildText',
    text:
      'Add your rates, availability, care format, and your approach to working with families. This is where families get to know you.',
  },
  {
    id: 'connect',
    labelId: 'ForProvidersHowItWorks.connectLabel',
    label: '03 · Connect',
    titleId: 'ForProvidersHowItWorks.connectTitle',
    title: 'Get discovered',
    textId: 'ForProvidersHowItWorks.connectText',
    text:
      "Families can find your profile, message you, set up a video intro call if they'd like, book your services, and pay securely, all in one place.",
  },
];

/**
 * Three steps from application to a discoverable provider profile.
 */
const HowItWorks = () => (
  <section className={css.root} id="how-it-works">
    <div className={css.inner}>
      <p className={css.eyebrow}>
        <FormattedMessage id="ForProvidersHowItWorks.eyebrow" defaultMessage="How it works" />
      </p>
      <h2 className={css.title}>
        <FormattedMessage
          id="ForProvidersHowItWorks.title"
          defaultMessage="Join in three simple steps"
        />
      </h2>
      <ol className={css.list}>
        {steps.map(step => (
          <li key={step.id} className={css.step}>
            <p className={css.label}>
              <FormattedMessage id={step.labelId} defaultMessage={step.label} />
            </p>
            <h3 className={css.stepTitle}>
              <FormattedMessage id={step.titleId} defaultMessage={step.title} />
            </h3>
            <p className={css.stepText}>
              <FormattedMessage id={step.textId} defaultMessage={step.text} />
            </p>
            {step.note ? (
              <p className={css.stepText}>
                <FormattedMessage id={step.noteId} defaultMessage={step.note} />
              </p>
            ) : null}
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
